// extracted by mini-css-extract-plugin
export default {"header__nav":"Header_header__nav__f95n4","header__figure":"Header_header__figure__fD1DW","header__image_icon":"Header_header__image_icon__NFO64"};